import { render, staticRenderFns } from "./MateriasFaltantes.vue?vue&type=template&id=3ca36fad&scoped=true"
import script from "./MateriasFaltantes.vue?vue&type=script&lang=js"
export * from "./MateriasFaltantes.vue?vue&type=script&lang=js"
import style0 from "./MateriasFaltantes.vue?vue&type=style&index=0&id=3ca36fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca36fad",
  null
  
)

export default component.exports